import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope)
      })
      .catch((err) => {
        console.log('Service Worker registration failed:', err)
      })
  })
}
ReactDOM.render(<App />, document.getElementById('root'))
